var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStorygenieLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    y2: 219.65,
    x2: 179.9,
    y1: 355.24,
    x1: 44.3,
    id: "e0219a89-6bd8-43ba-8eb6-5a90511ff58b_comp-kk2o699z"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0026ff",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0427ff",
    offset: 0.02
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5744fa",
    offset: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8a56f7",
    offset: 0.84
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9e5df6",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    y2: 169.29,
    x2: 235.69,
    y1: 285.63,
    x1: 119.35,
    id: "932e3901-c63f-43d7-adec-a6ba142f309f_comp-kk2o699z"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8d4dc9",
    offset: 0.18
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#eb7572",
    offset: 0.56
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff9e78",
    offset: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(16,16) scale(0.56)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M257 342.88 113.73 325.5c-19.46-2.36-37.32-20.22-39.73-39.68L56.66 142.54c-1.91-15.82 9.45-27.18 25.27-25.27l51.48 7 6.79 55.52-18.64-2.63c-5-.63-8.56 3-8 8.13l8.93 75.21c1.91 8.43 9.8 15.82 18.35 16.85l76.77 9.32c2.61-1.24 4.16-4 3.74-7.52l-1.51-16.36 56.45 6.95 5.93 47.92c1.97 15.77-9.4 27.15-25.22 25.22Z",
    fill: "url(#e0219a89-6bd8-43ba-8eb6-5a90511ff58b_comp-kk2o699z)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.3 177c-.66-5.5 3.3-9.46 8.8-8.79l18.09 2.34 1.09 9.18-18.72-2.56c-5-.63-8.56 3-8 8.13",
    fill: "#041f56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m222.59 287.24-4.93-.6c2.61-1.24 4.16-4 3.74-7.52l-1.52-16.37 9.8 1.81 1.7 13.89c.62 5.55-3.28 9.45-8.79 8.79Z",
    fill: "#041f56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m308.11 268.54-32.27-3.92-46.84-5.68-10.15-1.23-34.42-4.18c-16.18-1.95-31-16.8-33-33l-4.89-40.32-1.11-9.11-5.68-46.82-3.32-27.42c-1.53-12.53 7.49-21.54 20-20l59.78 7.25 4.79 39.11-32.83-4a4.79 4.79 0 0 0-5.58 5.59l.91 7.58a5.52 5.52 0 0 0 0 1.41l7.41 62.28c.75 6.38 6.49 12.24 12.75 13l61 7.56a5 5 0 0 0 2-.14l8.65 1.05a4.79 4.79 0 0 0 5.58-5.59l-3.95-32.54 43.44 5.26 7.75 63.82c1.51 12.56-7.49 21.56-20.02 20.04Z",
    fill: "url(#932e3901-c63f-43d7-adec-a6ba142f309f_comp-kk2o699z)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m222.17 133-33.81-4.19a4.15 4.15 0 0 0-4.88 3.58l-.91-7.58a4.79 4.79 0 0 1 5.58-5.59l32.83 4Z",
    fill: "#041f56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m275.31 217.58-8.65-1.05a4.25 4.25 0 0 0 2.9-4.85l-4-33.62 11.38 1.39 3.95 32.55a4.79 4.79 0 0 1-5.58 5.58Z",
    fill: "#041f56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m332.94 186.89-13.69-1.66-43.18-5.23-11.32-1.38-19.7-2.38c-10.22-1.25-19.59-10.62-20.83-20.84l-2.61-21.56-1.18-9.73-4.72-38.88-2.15-17.7c-.8-6.59 3.94-11.32 10.52-10.53L312 67.66c10.22 1.24 19.6 10.61 20.83 20.83l10.67 87.89c.76 6.62-3.97 11.31-10.56 10.51Z",
    fill: "#ffb469"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.22 150.41c-.53-2.3-.84-3.51-1.47-6h-.35c-2.6 3.52-8.34 6-16 5-10.84-1.37-17.33-8.21-18.4-16.1-1.79-13.18 9.13-17 30.59-14.43 0-.41-.07-.62-.11-1-.46-4.12-2.46-11.51-13.84-13-5.17-.66-11.18-.11-14.6 1.66-1.16-2.49-1.73-3.73-2.84-6.15 3.76-2.09 11.14-2.82 18.13-1.94 16.95 2.14 22.36 12.76 23.45 22.69.8 7.42 1.22 10.84 2.26 18.57a77.55 77.55 0 0 0 2.33 11.78Zm-4.65-25.34c-11-1.45-23.91-2.46-22.45 8.16.87 6.44 6.1 9.62 11.21 10.24 7.16.86 11.11-2.72 12.11-7a8.65 8.65 0 0 0 .19-2.85c-.45-3.43-.63-5.14-1.06-8.55Z",
    fill: "#2b1691"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.1 91.55c.41 3-.89 5.35-4.84 4.81-3.5-.48-7.07-3.43-7.45-6.44s2.8-5 6.38-4.47 5.49 3.03 5.91 6.1Zm-3.1 61.72c-1.79-18.43-3.46-29.54-5.89-49.2 4.71.63 6.65.93 9.83 1.24 2.34 19.62 3.92 30.5 5.66 49.08-3.25-.32-5.2-.58-9.6-1.12Z",
    fill: "#2b1691"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStorygenieLogo);
export default __webpack_public_path__ + "static/media/storygenie-logo.cdbbcfcbb763472298924d8f0af1c590.svg";
export { ForwardRef as ReactComponent };